module.exports = "<p>\n  example works!\n</p>\n"